import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import DeleteIcon from '@material-ui/icons/Delete';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';

interface ISimpleListItem extends ListItemProps {
    primaryText: string;
    secondaryText?: string;
    onClick?: any;
    id: string;
    avatarType?: 'image' | 'icon';
    avatarImg?: string;
    avatarIcon?: string;
    children?: any;
    handleRemove?: any;
}

const useStyles = makeStyles(theme => ({
    actions: {
        '&:hover': {
            opacity: 1,
        },
        // opacity: 0,
        transition: '.25s all',
    },
    child: {
        // display:'none'
    },
    handle: {
        color: 'gray',
        marginRight: theme.spacing(2),
    },
    hover: {},
    root: {
        '&:hover + $actions': {
            opacity: 1,
        },
        listStyle: 'none',
    },
    selected: {},
}));

export function SimpleListItem({
    avatarIcon,
    avatarImg,
    avatarType,
    children,
    handleRemove,
    id,
    onClick,
    primaryText,
    secondaryText,
}: ISimpleListItem) {
    const classes = useStyles();

    return (
        <ListItem button onClick={evt => (onClick ? onClick(evt, id) : undefined)}>
            <ListItemAvatar>
                {avatarType === 'image' ? (
                    <Avatar src={avatarImg} />
                ) : (
                    <Avatar>
                        <Icon>{avatarIcon}</Icon>
                    </Avatar>
                )}
            </ListItemAvatar>
            <ListItemText primary={primaryText} secondary={secondaryText} />
            <ListItemSecondaryAction classes={{ root: classes.actions }}>
                <IconButton aria-label="Delete" edge="end" onClick={handleRemove}>
                    <DeleteIcon />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
}

export default SimpleListItem;
